import { type Ref, watchEffect, unref, isReactive, toRaw } from 'vue'

export const waitForValue = async (value: Ref, expectedValue?: any) => {
  const hasExpectedValue = typeof expectedValue !== 'undefined'

  await new Promise((resolve) => {
    const preservedValue = unref(value)

    const unwatch = watchEffect(() => {
      if (hasExpectedValue ? unref(value) === expectedValue : preservedValue !== unref(value)) {
        resolve(undefined)

        setTimeout(() => {
          unwatch()
        })
      }
    })
  })
}

export function deepToRaw<T>(obj: T): T {
  if (isReactive(obj)) {
    obj = toRaw(obj)
  }

  for (const key in obj) {
    if (typeof obj[key] === 'object' && obj[key] !== null) {
      obj[key] = deepToRaw(obj[key])
    }
  }
  return obj
}
